
import { Component, Prop, Vue, Watch, Emit } from "vue-property-decorator";
import {
  ExamV2Custom,
  Mind,
  NoCompleteConfig,
  PsycGaugeConfig,
  TacMind,
  TacMindConfig
} from "@/lib/model/exambuilder/exam-v2";
import draggable from "vuedraggable";
import Pop from "../components/blue-pop.vue";
import Loading from "../../../components/loading.vue";
import { config } from "vue/types/umd";
import Auth from "@/lib/common/auth";
import gateway from "@/lib/request/gateway";
import InputNumberV3 from "@/views/ai-builder-v3/components/inputNumberV3.vue";

@Component({
  components: {
    InputNumberV3,
    draggable,
    Loading,
    Pop
  }
})
export default class SetQuestion extends Vue {
  @Prop({ type: ExamV2Custom, default: new ExamV2Custom() })
  exam!: ExamV2Custom; //考试Model
  @Prop({ type: Boolean, default: false }) isEdit!: boolean; //是否编辑页面
  @Prop({}) companyPower!: any; //公司权限
  @Prop({}) setWeb!: boolean; //公司权限
  @Prop({ type: Boolean, default: false }) isCandidateUsed!: boolean; //是否已有人作答

  @Watch("exam", { deep: true, immediate: true })
  initData() {
    if (this.exam.psycGaugeConfig.psycGaugeId === 5) {
      this.dvfVersionFormValue = 1;
      this.showDvfVersion = 1;
    } else if (this.exam.tacPsycGaugeConfigList.some(item => item.id === 1)) {
      // TODO tac dvf 心理量表id为1，当全部使用新的心理量表时，应该弃用这种写法
      this.dvfVersionFormValue = 2;
      this.showDvfVersion = 2;
    }
    this.initTacMindConfigMap();
  }

  showDetail = false;
  gameDetail = false;
  // 数据加载完成前不展示空页面
  dataLoaded = false;
  now = 1; //类别

  // 心理量表
  showFIVE = false;
  handTestList: string[] = [
    "fingerCheckTestComplete",
    "fingerCheckTestFlexible",
    "fingerCheckTestScar"
  ];
  mindType = 0; //点开的心理量表
  fiveOptionEditingList: any = {}; //正在选择中的维度
  mindLogo = require("@/assets/ai-builder/mind-logo.png");
  bigFiveTypeEnum = [1, 4]; //大五人格类型id
  singleDimensionTypeEnum = [3, 5]; // 单维度心理测评id
  mindList: PsycGaugeConfig[] = [];
  tacMindList: TacMind[] = [];

  get showTacMindList() {
    // dvf 版本选择为1时 ，不能展示 tacMind 里面的dvf量表
    if (this.showDvfVersion === 1) {
      return this.tacMindList.filter(item => item.groupNum !== 1);
    }

    return this.tacMindList;
  }

  get showMindList() {
    // dvf 版本选择为2时 ，不能展示 mindList 里面的dvf量表
    if (this.showDvfVersion === 2) {
      return this.mindList.filter(item => item.psycGaugeId !== 5);
    }

    return this.mindList;
  }

  get mindDetail() {
    if (!this.detailModel.item) {
      return {
        id: 0,
        groupNum: 0,
        name: "",
        detail: "",
        img: ""
      };
    }

    if (this.detailModel.version === 1) {
      return {
        id: (this.detailModel.item as PsycGaugeConfig).psycGaugeId,
        groupNum: 0,
        name: (this.detailModel.item as PsycGaugeConfig).psycGaugeName,
        detail: (this.detailModel.item as PsycGaugeConfig).descriptionDetail,
        img: (this.detailModel.item as PsycGaugeConfig).descriptionImgUrl
      };
    } else {
      return {
        id: (this.detailModel.item as TacMind).id,
        groupNum: (this.detailModel.item as TacMind).groupNum,
        name: (this.detailModel.item as TacMind).name,
        detail: (this.detailModel.item as TacMind).descriptionDetail,
        img: ""
      };
    }
  }

  // 新版本心理测评量表配置
  showDvfConfig = false;
  tacMindConfigMap: { [key: number]: TacMindConfig } = {};
  tacMindConfig = new TacMindConfig();
  activeTacMindId = 0;

  get activeTacMind() {
    return this.tacMindList.find(item => item.id === this.activeTacMindId);
  }

  dvfVersionFormValue = 2;
  showDvfVersion = 2;
  detailModel: {
    version?: number;
    item?: PsycGaugeConfig | TacMind;
  } = {};

  initTacMindConfigMap() {
    this.tacMindList.forEach(item => {
      const config = this.exam.tacPsycGaugeConfigList.find(
        c => c.id === item.id
      );

      if (!config) {
        this.tacMindConfigMap[item.id] = new TacMindConfig().assign({
          id: item.id,
          dimensionParams: item.dimensionList.map(d => ({
            id: d.id,
            segScore: [95, 90]
          }))
        });
        return;
      }

      this.tacMindConfigMap[item.id] = new TacMindConfig().assign({
        ...config,
        segScore: config.dimensionParams[0]?.segScore || [95, 90]
      });
    });
  }

  handleShowTacMindConfig(id: number) {
    this.showDvfConfig = true;
    this.activeTacMindId = id;
    this.tacMindConfig.assign(this.tacMindConfigMap[id]);
  }

  get token() {
    return Auth.token;
  }
  get hasAiPower() {
    return (
      this.handTestList.includes("armCheckTestHide") ||
      this.handTestList.includes("armCheckTestComplete")
    );
  }
  //大五人格 所有子维度  以及类似大五人格维度 isLeaf = 1 可使用的维度
  get fiveMindSonList() {
    const list: any[] = [];
    const index = this.mindList?.findIndex(
      d => d.psycGaugeId === this.mindType
    );
    this.mindList?.[index]?.dimensionList.forEach((d: any) => {
      if (d.isLeaf === 1) list.push(d);
      d?.subDimensionList.forEach((m: any) => {
        if (m.isLeaf === 1) list.push(m);
      });
    });
    return list;
  }
  //大五人格 已选子维度 name 题数
  fiveSelectSon = { name: "", questionNum: 0 };
  getFiveSelectSon() {
    const res = { name: "", questionNum: 0 };
    this.exam.psycGaugeConfig.psycGaugeSubDimensionIdList.forEach(
      (d: number) => {
        this.fiveMindSonList.forEach((m: any) => {
          if (d === m.psycGaugeDimensionId) {
            res.name += m.psycGaugeDimensionName + "、";
            res.questionNum += Number(m.questionCount);
          }
        });
      }
    );
    res.name = res.name.slice(0, res.name.length - 1);
    this.fiveSelectSon = res;
  }
  //已选的心理量表 全部信息
  get mindTypeNow() {
    const psyc = this.mindList.find(
      d => d.psycGaugeId === this.exam.psycGaugeConfig.psycGaugeId
    );
    // TODO 心理量表支持多选时，应该弃用这种写法
    const tacMind = this.tacMindList.find(
      d => d.id === this.exam.tacPsycGaugeConfigList[0]?.id
    );

    return {
      name: psyc?.psycGaugeName || tacMind?.name || ""
    };
  }

  get hasUsedEffectV3() {
    // 新版面试在旧版中不允许修改，除非在setweb下
    return !this.setWeb && this.isCandidateUsed;
  }
  get notAllow() {
    return this?.companyPower?.enablePsycTest !== 1;
  }
  get notAllowGame() {
    return this?.companyPower?.enableGameTest !== 1;
  }

  // 二要素（身份证、姓名）验证
  get hasVerifyNameIdcard() {
    return this.companyPower?.enableNameIdCheck === 1;
  }

  // 设置使用身份信息验证(二要素核验)
  setUseNameIdCheckConfig(value: number) {
    if (this.hasVerifyNameIdcard || this.exam.nameIdCheckConfig.use === 1) {
      this.exam.nameIdCheckConfig.use = value;
      if (!this.exam.nameIdCheckConfig.maxSubmitNumber) {
        this.exam.nameIdCheckConfig.maxSubmitNumber = 2;
      }
      if (!this.exam.nameIdCheckConfig.noticeMessage) {
        this.exam.nameIdCheckConfig.noticeMessage =
          "姓名或证件号与实际证件不匹配，请重新输入";
      }
      this.change();
    }
  }

  get hasFacePower() {
    return this.companyPower.livenessRecognition === 1;
  }
  get hasReplaceCheckPower() {
    return this.companyPower.enableReplacePersonCheck === 1;
  }
  get hasFaceDetectionPower() {
    return this.companyPower.enableFaceDetection === 1;
  }

  loading = false;
  uploadImg(data: { filename: string; file: File }) {
    const { filename, file } = data;
    console.log(filename);
    this.loading = true;
    const isJPG =
      file.type === "image/jpeg" ||
      file.type === "image/jpg" ||
      file.type === "image/png";
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isJPG) {
      this.$message.error("上传图片只能是 JPG/JPEG/PNG 格式!");
      this.loading = false;
      return false;
    }
    if (!isLt2M) {
      this.$message.error("上传图片过大!");
      this.loading = false;
      return false;
    }
    // 上传图片到oss
    gateway.anonymousGetPostPolicy(file.name).then((postRes: any) => {
      if (postRes) {
        const tempUrl = postRes.cdn + "/" + encodeURIComponent(postRes.dir);
        gateway
          .upload(postRes, file)
          .then((res: any) => {
            console.log("upload res : ", res);
          })
          .finally(() => {
            this.loading = false;
            this.exam.fingerConfig.wsaCodeUrl = tempUrl;
          });
      }
    });
  }
  //公司是否有权限
  powerCheck(key: string) {
    return this.companyPower?.[key] === 1;
  }

  changeOperate(value: number, config: NoCompleteConfig) {
    if (config.operate === 2 && value === 1) {
      config.operate = 1;
    }
    if (value === 2 && config.operate === 1) {
      config.operate = 2;
    }
  }

  changeHandTestList(testList: string[]) {
    this.exam.fingerConfig.fingerCheckTestComplete = testList.includes(
      "fingerCheckTestComplete"
    );
    this.exam.fingerConfig.fingerCheckTestFlexible = testList.includes(
      "fingerCheckTestFlexible"
    );
    this.exam.fingerConfig.fingerCheckTestScar = testList.includes(
      "fingerCheckTestScar"
    );
    this.exam.fingerConfig.armCheckTestHide = testList.includes(
      "armCheckTestHide"
    );
    this.exam.fingerConfig.armCheckTestComplete = testList.includes(
      "armCheckTestComplete"
    );
  }

  //计算小项选中数量
  getNum(str: string) {
    let num = 0;
    if (str === "身份核验") {
      num += this.exam.livenessRecognition === 1 ? 1 : 0;
      num += this.exam.replacePersonCheck === 1 ? 1 : 0;
      num += this.exam.faceDetection === 1 ? 1 : 0;
      return num ? `已选${num}项` : `未使用`;
    }
    if (str === "背调服务") {
      num = this.exam.bgCheckProductId;
      // 是否选择了二要素
      const hasNameIdCheck = this.exam.nameIdCheckConfig.use === 1 ? 1 : 0;
      let count = 0;
      if (num !== 0) {
        count += num === 4 ? 3 : [2, 3, 8].includes(num) ? 2 : 1;
      }
      if (hasNameIdCheck > 0) {
        count += hasNameIdCheck;
      }
      return count ? `已选${count}项` : "未使用";
    }
    if (str === "形体检测") {
      num += this.exam.fingerTest === 1 ? 1 : 0;
      num += this.exam.colorTest === 1 ? 1 : 0;
      return num ? `已选${num}项` : `未使用`;
    }
  }

  async mounted() {
    await this.selectType(1);
    const keys = [
      "armCheckTestComplete",
      "armCheckTestHide",
      "fingerCheckTestComplete",
      "fingerCheckTestFlexible",
      "fingerCheckTestScar"
    ];
    if (this.isEdit) {
      this.handTestList = [];
      keys.forEach(key => {
        if (this.exam.fingerConfig[key]) {
          this.handTestList.push(key);
        }
      });
    }
    this.dataLoaded = true;
  }
  //选择类别
  async selectType(i: number) {
    this.now = i;
    if (i === 1) {
      await this.getMindList();
    }
  }
  //获取所有心理量表
  async getMindList() {
    try {
      const res = await Mind.get();

      if (res.data.code !== 0) return;

      this.mindList = res.data.data.list;
      this.tacMindList = res.data.data.tacList
        .filter((item: TacMind) => item.id === 1)
        .map((item: TacMind) => {
          return new TacMind().assign(item);
        });
      this.checkMindSelectedInfo();
      this.initTacMindConfigMap();
    } catch (err) {
      console.error(err);
    }
  }

  handleChangeDvfVersion() {
    this.showDvfVersion = this.dvfVersionFormValue;

    this.tacMindConfig.dimensionParams.forEach(item => {
      item.segScore = this.tacMindConfig.segScore;
    });

    this.tacMindConfigMap[this.activeTacMindId].assign(this.tacMindConfig);

    // 如果当前选择的不是dvf量表，不做操作
    if (
      this.exam.psycGaugeConfig.psycGaugeId !== 5 &&
      !this.exam.tacPsycGaugeConfigList.some(item => item.id === 1)
    ) {
      return (this.showDvfConfig = false);
    }

    console.log("改变dvf量表版本");

    if (this.dvfVersionFormValue === 1) {
      this.okSingleDimension(5);
    } else {
      this.okTacMind(1);
    }

    this.showDvfConfig = false;
  }

  // 找到已选心理量表id
  checkMindSelectedInfo() {
    this.mindType = this.exam?.psycGaugeConfig?.psycGaugeId || 0;
    this.getFiveSelectSon();
  }
  //大五人格 已选中子维度class
  setChked(id: number) {
    return this.fiveOptionEditingList?.psycGaugeSubDimensionIdList?.find(
      (res: number) => res === id
    );
  }
  //大五人格 选
  selectFiveSon(id: number) {
    const i = this.fiveOptionEditingList.psycGaugeSubDimensionIdList?.findIndex(
      (res: number) => res === id
    );
    if (i === -1) {
      this.fiveOptionEditingList.psycGaugeSubDimensionIdList.push(id);
    } else {
      this.fiveOptionEditingList.psycGaugeSubDimensionIdList.splice(i, 1);
    }
  }
  beforeOpen(item: PsycGaugeConfig | TacMind, mindVersion = 1) {
    if (this.hasUsedEffectV3) return;

    if (mindVersion === 1) {
      this.mindType = (item as PsycGaugeConfig).psycGaugeId;
      if (
        this.bigFiveTypeEnum.includes((item as PsycGaugeConfig).psycGaugeId)
      ) {
        return this.openFIVE();
      }
    }

    return this.openDetail(item, mindVersion);
  }

  //大五 打开  生成编辑用的副本
  openFIVE(pid?: number) {
    if (this.notAllow) return false;
    this.mindType = pid || this.mindType;
    this.fiveOptionEditingList = JSON.parse(
      JSON.stringify(this.exam.psycGaugeConfig)
    );
    if (this.exam.psycGaugeConfig.psycGaugeId !== this.mindType) {
      //切换了不同量表 初始值先置空
      this.fiveOptionEditingList.psycGaugeSubDimensionIdList = [];
    }
    this.showFIVE = true;
  }
  //大五弹窗 取消
  cancelFIVE() {
    this.showFIVE = false;
  }
  //大五弹窗 确认
  okFIVE() {
    if (this.notAllow) return false;
    this.exam.tacPsycGaugeConfigList = [];
    //0滤掉
    this.fiveOptionEditingList.psycGaugeSubDimensionIdList = this.fiveOptionEditingList.psycGaugeSubDimensionIdList.filter(
      (d: number) => {
        return d !== 0;
      }
    );
    if (this.fiveOptionEditingList.psycGaugeSubDimensionIdList.length > 0) {
      this.exam.psycGaugeConfig = JSON.parse(
        JSON.stringify(this.fiveOptionEditingList)
      );
      this.exam.psycGaugeConfig.psycGaugeId = this.mindType;
      this.$forceUpdate();
      this.getFiveSelectSon();

      this.showFIVE = false;
      this.change();
    } else {
      this.$message.warning("至少选择一个维度");
    }
  }
  // 单维度心理测评弹窗 确认
  okSingleDimension(psycGaugeId: number) {
    if (this.notAllow) return false;
    this.exam.psycGaugeConfig.psycGaugeId = psycGaugeId;
    this.exam.psycGaugeConfig.psycGaugeSubDimensionIdList = [];
    this.exam.tacPsycGaugeConfigList = [];
    this.$forceUpdate();
    this.showDetail = false;
    this.change();
  }
  // 新版心理量表使用
  okTacMind(id: number) {
    if (this.notAllow) return false;

    const index = this.exam.tacPsycGaugeConfigList.findIndex(
      item => item.id === id
    );

    if (index >= 0) {
      this.exam.tacPsycGaugeConfigList.splice(index, 1);
    }

    this.exam.tacPsycGaugeConfigList.push(this.tacMindConfigMap[id]);
    this.exam.psycGaugeConfig.psycGaugeId = 0;
    this.exam.psycGaugeConfig.psycGaugeSubDimensionIdList = [];
    this.$forceUpdate();
    this.showDetail = false;
    this.change();
  }

  sn() {
    if (this.notAllow) return false;
    this.exam.psycGaugeConfig.psycGaugeId = 0;
    this.exam.psycGaugeConfig.psycGaugeSubDimensionIdList = [];
    this.exam.tacPsycGaugeConfigList = [];
    this.change();
  }
  openDetail(item: PsycGaugeConfig | TacMind, mindVersion = 1) {
    this.detailModel = {
      version: mindVersion,
      item: item
    };
    this.$nextTick().then(() => {
      this.showDetail = true;
    });
  }
  okDetailFive() {
    this.openFIVE();
    this.showDetail = false;
  }

  checkData() {
    let res = true;
    if (
      this.exam.psycGaugeConfig.psycGaugeId === 1 &&
      this.exam.psycGaugeConfig.psycGaugeSubDimensionIdList.length < 1
    ) {
      res = false;
      this.$message.warning("若使用心理测评·OCEAN人格评估，请至少选择一个维度");
    }
    if (!this.isEdit && !this.setWeb && this.exam.colorTest === 1) {
      this.exam.colorConfig.type = 2;
    }
    if (
      this.hasAiPower &&
      (this.exam.fingerConfig.noRollUpSleevesConfig.operate === 2 ||
        this.exam.fingerConfig.noArmCompleteConfig.operate === 2) &&
      !this.exam.fingerConfig.wsaCodeUrl &&
      this.setWeb
    ) {
      // setweb下，手臂检测有ai能力，且选择了至少一个阻断，就必须上传二维码
      res = false;
      this.$message.warning("手臂检测选择了至少一个阻断，必须上传二维码");
    }
    if (this.hasVerifyNameIdcard) {
      const {
        use,
        maxSubmitNumber,
        noticeMessage
      } = this.exam.nameIdCheckConfig;
      if (use === 1 && !maxSubmitNumber) {
        res = false;
        this.$message.warning("请输入身份信息验证异常重试次数");
      }
      if (use === 1 && !noticeMessage) {
        // res = false;
        // this.$message.warning("请输入校验失败前端展示文案");
        this.exam.nameIdCheckConfig.assign({
          noticeMessage: "姓名或证件号与实际证件不匹配，请重新输入"
        });
      }
    } else {
      if (this.exam.nameIdCheckConfig.use === 1) {
        res = false;
        this.$message.warning(
          "当前公司没有开启身份信息验证（二要素核验）功能，请关闭"
        );
      }
    }
    return res;
  }
  setGame(index = 0) {
    if (this.hasUsedEffectV3) return false;
    if (this.notAllowGame) return false;
    this.exam.gameTestConfig = [index];
    this.change();
  }
  //设置背调信息
  setBgCheckProductId(index: number, chk: boolean) {
    // "S社金身"=bgCheckProductId
    enum allType {
      "s000" = 0,
      "s001" = 1,
      "s010" = 7,
      "s011" = 3,
      "s100" = 6,
      "s101" = 2,
      "s110" = 8,
      "s111" = 4
    }
    const source = allType[this.exam.bgCheckProductId].split("");
    source[index] = String(Number(chk));
    this.exam.bgCheckProductId = allType[source.join("")];
    this.change();
  }

  @Emit()
  nextStep() {
    return;
  }
  @Emit()
  change() {
    return;
  }
}
